import "./src/styles/global.css"
import React from 'react';
import {AnimatePresence} from 'framer-motion';
import Layout from "./src/layouts/index";

// @ts-ignore
export const wrapPageElement = ({element, props} ) => (
    <Layout {...props}><AnimatePresence mode={"wait"}>{element}</AnimatePresence></Layout>
);